import React from "react";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import { type IKuikaButtonStatusLabels, type KuikaButtonStatus } from "../../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper";
import KuikaH5 from "../../ui-kit/typography/H5/H5";
import KuikaText from "../../ui-kit/typography/Text/Text";
import "./branching-modal.scss";

export interface IDeleteBranchModalProps {
  showModal: boolean;
  branchName?: string;
  inProgress?: boolean;
  /**
   * Where the commit stands (`KuikaButton` `status`). Given, the commit button carries it —
   * the busy word, then its ✓ or "Try again" — and `inProgress` no longer draws on it.
   */
  status?: KuikaButtonStatus;
  onClose: () => void;
  onDelete: () => void;
}

/** Deleting says its outcome in a toast (#9), so it never shows a ✓. */
const DELETE_STATUS_LABELS: IKuikaButtonStatusLabels = { loading: "Deleting" };

const DeleteBranchModal: React.FC<IDeleteBranchModalProps> = ({
  showModal,
  branchName,
  inProgress,
  status,
  onClose,
  onDelete
}) => {
  const footer = (
    <KModalFooter
      onCancel={onClose}
      submitLabel="Delete"
      submitTone="danger"
      onSubmit={onDelete}
      loading={inProgress}
      status={status}
      statusLabels={DELETE_STATUS_LABELS}
    />
  );

  return (
    <KModal showModal={showModal} closeModal={onClose} header="Delete Branch" footer={footer} width={360} centered>
      <div className="kuika-branching-modal">
        <div className="kuika-branching-modal__header">
          <KuikaModalIconWrapper iconName="trash" intent="destructive" />
          <div className="kuika-branching-modal__title">
            <KuikaH5>Delete Branch</KuikaH5>
          </div>
        </div>
        <div className="kuika-branching-modal__content">
          <div className="kuika-branching-modal__description">
            <KuikaText>
              Are you sure you want to delete {branchName ? `“${branchName}”` : "this branch"}? All commits, staged
              changes, and entities created only on this branch will be permanently removed. This cannot be undone.
            </KuikaText>
          </div>
        </div>
      </div>
    </KModal>
  );
};

export default DeleteBranchModal;
